import {Component, Input, OnInit} from "@angular/core";
import {DialogComponent} from '../../../../../ng2-bootstrap-modal/dialog.component';
import {DialogService} from '../../../../../ng2-bootstrap-modal/dialog.service';
import {Utils} from "../../../utils/utils";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {Config} from "../../../../config/config";
import {Website} from "../../../../websites/website/website";
import {DbResponse} from "../../../interceptors/db-response";
import {HostingService} from "../../../../websites/website/hosting/hosting.service";
import {filter, first} from "rxjs/operators";

export interface IConfirmDialogData {
    header: string;
    message: string;
    buttonWidth?: any;
    cancelButtonText?: string;
    cancelButtonClass?: string;
    confirmButtonText: string;
    confirmButtonClass?: string;
    params?: any;
    size?: string;
    height?: string;
    website?: Website;
    screen?: any;
    ssl?: any;
    pointed?: any;
    checkSubdomain?: boolean;
    makePrimary?: boolean;
    is10webDomain?: boolean;
    disableMakePrimary?: boolean;
    alignLeft?: boolean;
    alignButtonsRight?: boolean;
    fromStaging?: boolean;
    width?: string;
    hasCloseButton?: boolean;
}

@Component({
    selector: 'db-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
    standalone: false
})
export class ConfirmDialogComponent extends DialogComponent<IConfirmDialogData, any> implements OnInit, IConfirmDialogData {

    @Input() companyName: string;
    @Input() header: string;
    @Input() message: string;
    @Input() buttonWidth?: any;
    @Input() cancelButtonText?: string;
    @Input() cancelButtonClass: string = 'ds-btn';
    @Input() confirmButtonText: string;
    @Input() confirmButtonClass: string = "ds-btn-red";
    @Input() params?: any;
    @Input() size?: string;
    @Input() height?: string = 'auto';
    @Input() website?: Website;
    @Input() screen?: any;
    @Input() ssl?: any;
    @Input() pointed?: any;
    @Input() checkSubdomain?: boolean;
    @Input() makePrimary?: boolean;
    @Input() is10webDomain?: boolean;
    @Input() disableMakePrimary?: boolean;
    @Input() alignLeft?: boolean = false;
    @Input() fromStaging?: boolean = false;
    @Input() alignButtonsRight?: boolean = false;
    @Input() width?: string;
    @Input() hasCloseButton?: boolean = false;

    public changes: any;
    public confirmDialog: FormGroup;
    public confirmationSubdomain: any;
    public formSubmitted: boolean;
    public enableSSL: FormControl;
    public hostName: string = Config.hostname;
    public configHostnameList: string[] = Config.hostnameList;

    constructor(
        private _dialogService: DialogService,
        private _hostingService: HostingService
    ) {
        super(
            _dialogService
        );
    }

    ngOnInit() {
        if (this.checkSubdomain) {
            this.confirmationSubDomain();
        }
        // this.getHostName();
        this.enableSSL = new FormControl(!this.ssl);
        this.formSubmitted = false;
        if (this.params) {
            if (this.params.pluginsCount) {
                this.params.pluginsCount = Utils.wordByCount("plugin", this.params.pluginsCount);
            }
            if (this.params.themesCount) {
                this.params.themesCount = Utils.wordByCount("theme", this.params.themesCount);
            }
        }
    }

    public getHostName(): void {
        this._hostingService.getUserMainDomain()
            .pipe(filter((response: DbResponse) => !!response),
                first())
            .subscribe((response: DbResponse) => {
                if (response.success) {
                    this.hostName = response.data.domain;
                    this.confirmationSubDomain();
                }
            });
    }

    public confirmationSubDomain(): void {
        this.confirmationSubdomain = this.website && this.website.name.replace("https://", "");
        this.configHostnameList.map(hostname => {
            if (this.website && this.website.name.indexOf(hostname) !== -1) {
                return this.confirmationSubdomain = this.confirmationSubdomain.split("." + hostname)[0].replace("-dev", "");
            }
        });
        this.confirmDialog = new FormGroup({
            'subdomain': new FormControl('', [Validators.required, Validators.minLength(1)])
        }, this.checkIfMatchingName(this.confirmationSubdomain, 'subdomain'));
    }

    public checkIfMatchingName(websiteTitle, siteUrlConfirmationKey: string): any {
        return (group: FormGroup) => {
            const siteUrlConfirmationKeyInput = group.controls[siteUrlConfirmationKey];
            if (websiteTitle !== siteUrlConfirmationKeyInput.value) {
                return siteUrlConfirmationKeyInput.setErrors({notEquivalent: true});
            } else {
                return siteUrlConfirmationKeyInput.setErrors(null);
            }
        };
    }

    public cancel(): void {
        this.result = false;
        this.close();
    }

    public confirm(): void {
        this.formSubmitted = true;
        if (this.website) {
            if (this.confirmDialog.valid || this.makePrimary) {
                let enableSsl = this.enableSSL.value;
                if (!this.pointed || this.is10webDomain) {
                    enableSsl = false;
                }
                this.result = this.screen === 'primary-domain' ? {enableSSL: enableSsl} : true;
                this.close();
            }
        } else {
            this.result = true;
            this.close();
        }
    }

}
